import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "../assets/styles/CompanyDetails.css";
import { Link } from "react-router-dom";

gsap.registerPlugin(ScrollTrigger);

function CompanyDetails({ data }) {
  const companyRef = useRef(null);

  useEffect(() => {
    gsap.fromTo(
      companyRef.current,
      { opacity: 0, scale: 0.9 },
      {
        opacity: 1,
        scale: 1,
        duration: 1.2,
        ease: "power3.out",
        scrollTrigger: {
          trigger: companyRef.current,
          start: "top 80%",
          toggleActions: "play none none reverse",
        },
      }
    );
  }, []);

  return (
    <div
      className="company-content font-mono"
      style={{
        backgroundImage: `url(${data.image})`,
      }}
    >
      <div className="company-container">
        <div
          ref={companyRef}
          className="company-details text-left opacity-0 scale-90"
        >
          <h1 className="text-5xl pb-12 font-bold">{data.title}</h1>
          <p className="text-xl font-poppins">{data.details}</p>
          <div className="flex justify-end">
            <Link to={data.link}>
              <button className="mt-8 bg-[#cc673d] border-[#cc673d] text-white p-3 btn-effect">
                {data.linkTitle}
              </button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CompanyDetails;
